import { createContext, useContext, useEffect, useState } from 'react';
import { getAllCompanies, getFingertipsLinks, getOtherCompanyBenefits } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type PensionIndexState = {
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const PensionIndexStore = createContext<PensionIndexState>({
  fingertipLinks: [],
  companiesMessages: [],
  otherCompanyBenefits: [],
});

const { Provider } = PensionIndexStore;

export const PensionIndexProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [pensionIndexState, setPensionIndexState] = useState<PensionIndexState>(
    {
      fingertipLinks: [],
      companiesMessages: [],
      otherCompanyBenefits: [],
    }
  );

  useEffect(() => {
    let fingertipLinks = getFingertipsLinks('persona-db');
    let companiesMessages = getAllCompanies('persona-db');
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setPensionIndexState({
      fingertipLinks,
      companiesMessages,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={pensionIndexState}>{children}</Provider>;
};
